import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, Box, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField } from '@mui/material';
import imgFondo from '../../assets/pino.png';
import { exportComponentAsPNG } from "react-component-export-image";
import QRCode from 'qrcode.react';
import { ButtonStyleAzul, ButtonStyleWhite } from "../../styles/Styles";
import { Send } from "@mui/icons-material";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import { postCancelarQr, postConsultarPagos, postDetailsQr } from "../../api/Api";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const QrComponents = ({ handleCancelarQr, open, dataQr, dataUser, monto, qrHub, setSeverity, setMensaje, setOpenAlert }) => {
    const QRRef = useRef();
    const intervalQr = useRef(null);
    const timerRef = useRef(null);
    const tickRef = useRef(null);

    const [tiempoRestante, setTiempoRestante] = useState(300);

    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);



    useEffect(() => {
        let intervalApi = 3000;
        let timerCloseApi = 300000;//tiempo de 5 minutos


        intervalQr.current = setInterval(() => {

            console.log('consultando qr');
            handleDetailsQr();

        }, intervalApi);

        //se cancela en 5 minutos, si no se paga el qr || se cancela si el usuario cierra el modal
        timerRef.current = setTimeout(() => {
            console.log('termino los 1 minuto')
            handleCancelarQrAction();
            setOpenAlert(true);
            setSeverity('warning');
            setMensaje('El tiempo para pagar ha expirado');
        }, timerCloseApi);

        //contador visible que decrementa cada segundo
        tickRef.current = setInterval(() => {
            setTiempoRestante(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => {
            clearInterval(intervalQr.current);
            clearTimeout(timerRef.current);
            clearInterval(tickRef.current);
        }

    }, []);

    const formatTiempo = (segundos) => {
        const min = Math.floor(segundos / 60);
        const sec = segundos % 60;
        return `${min}:${sec < 10 ? '0' + sec : sec}`;
    };




    const downloadPng = async () => {
        await exportComponentAsPNG(QRRef, { fileName: 'qr_transferencia' });
    };

    const handleDetailsQr = () => {
        let data = {};
        data.idQr = dataQr.idQr;
        data.codComercio = stateToken.codeComercio;
        data.qrHub = qrHub;

        postDetailsQr(data)
            .then((response) => {
                //valido que la respuesta header.codRespuesta === 0
                if(response.header.codRespuesta === '0'){
                    console.log("response-details", response);
                    //si el array de pagis esta vacio, quiere decir que no se ha pagado, si no esta vacio, quiere decir que se ha pagado
                    if(response.data.pagos.length > 0){
                        console.log("pagado");
                        clearInterval(intervalQr.current);
                        clearTimeout(timerRef.current);

                        if (qrHub === false) {
                            const fechaHoy = dayjs().format('DD-MM-YYYY');
                            const bodyConsultar = {
                                fechaInicio: fechaHoy,
                                fechaFin: fechaHoy,
                                codComercio: '',
                                idQr: response.data.pagos[0].idQr,
                                idPagoQr: response.data.pagos[0].idPagoQr,
                                importe: '',
                                docUsuario: '',
                                qrHub: false,
                                filtro: { posInicial: 0, cantidad: 1 }
                            };

                            postConsultarPagos(bodyConsultar)
                                .then((consultaResponse) => {
                                    let idTxDestinatario = '';
                                    if (consultaResponse.header.codRespuesta === '0' && consultaResponse.lista && consultaResponse.lista.length > 0) {
                                        idTxDestinatario = consultaResponse.lista[0].idTxDestinatario;
                                    }
                                    handleCancelarQr();
                                    history('/home/payment/confirmacion', { state: { ...response, idTxDestinatario }, replace: true });
                                })
                                .catch((err) => {
                                    console.warn("error-consultar-pago", err);
                                    handleCancelarQr();
                                    history('/home/payment/confirmacion', { state: response, replace: true });
                                });
                        } else {
                            const idOperacion = response.data.pagos[0]?.idOperacion || '';
                            handleCancelarQr();
                            history('/home/payment/confirmacion', { state: { ...response, idOperacion, _esSip: true }, replace: true });
                        }
                    }

                }else{
                    console.warn("error-details-qr", response);
                    clearInterval(intervalQr.current);
                    clearTimeout(timerRef.current);
                    handleCancelarQr();
                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(response.header.txtRespuesta);
                }
            })
    }


    const handleCancelarQrAction = () => {
        console.log("handleCancelarQrAction");
        let data = {};
        data.idQr = dataQr.idQr;
        data.qrHub = qrHub;

        clearInterval(intervalQr.current);
        clearTimeout(timerRef.current);
        handleCancelarQr();

        postCancelarQr(data)
            .then((response) => {
                if (response.codRespuesta !== '0') {
                    console.warn("error-cancelar-qr", response);
                    setOpenAlert(true);
                    setSeverity('error');
                    setMensaje(response.txtRespuesta);
                }
            })
            .catch((error) => {
                console.warn("error-cancelar-qr", error);
                setOpenAlert(true);
                setSeverity('error');
                setMensaje('No se pudo cancelar el QR');
            });
    }


    const handleCaptureMobile = () => {
        html2canvas(QRRef.current)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                // console.log("imgData", imgData);
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'share', data: imgData, fileName: 'qr_transferencia' }));
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    //usar share para compartir el qr, no se si funciona en todos los navegadores
    const handleShare = async () => {

        //pasar el qr a base64=> solo pasa el qr, no envia el monto ni el nombre del usuario
        // const canvas = QRRef.current.querySelector('canvas');
        // const dataURL = canvas.toDataURL();


        //enviar el mensaje a la webView de react native, para que se pueda compartir
        if (window.ReactNativeWebView) {//se valida si es una app de react native
            handleCaptureMobile();
        } else {
            console.log("es el navegador web");
            downloadPng();
        }

    }


    const handleRedirectConfirmacion = () => {
        // history('/home/payment/confirmacion', { state: body, replace: true });
    }



    return (
        <Dialog
            aria-labelledby="qr-dialog-title"
            open={open}
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    maxWidth: '420px',
                    width: '92%',
                    maxHeight: '95vh',
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                    margin: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)',
                    color: '#fff',
                    padding: '14px 20px',
                    textAlign: 'center',
                    flexShrink: 0,
                }}
            >
                <Typography variant="caption" sx={{ opacity: 0.85, letterSpacing: 1.5, fontWeight: 600 }}>
                    PAGÁ CON QR
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700, mt: 0.3, lineHeight: 1.2 }}>
                    Escaneá el código
                </Typography>
            </Box>

            <Box
                sx={{
                    padding: '16px',
                    backgroundColor: '#f7f9fc',
                    overflowY: 'auto',
                    flex: 1,
                }}
            >
                <Box
                    ref={QRRef}
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: '14px',
                        padding: '16px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                    }}
                >
                    <Box textAlign="center" sx={{ mb: 1 }}>
                        <Typography
                            variant="caption"
                            sx={{ color: '#888', letterSpacing: 0.5, fontWeight: 600 }}
                        >
                            COMERCIO
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600, color: '#222', mt: 0.2, lineHeight: 1.3 }}
                        >
                            {dataUser}
                        </Typography>
                    </Box>

                    {monto !== '0' && (
                        <Box
                            textAlign="center"
                            sx={{
                                backgroundColor: '#eef4ff',
                                borderRadius: '10px',
                                padding: '8px',
                                mb: 1,
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{ color: '#1976d2', fontWeight: 600, letterSpacing: 0.5 }}
                            >
                                MONTO A PAGAR
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 700, color: '#0d47a1', mt: 0.2, lineHeight: 1.2 }}
                            >
                                {`${Number(monto).toLocaleString('es-PY', { minimumFractionDigits: 0 })} Gs.`}
                            </Typography>
                        </Box>
                    )}

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            border: '1px solid #e0e7f1',
                            borderRadius: '12px',
                            padding: '8px',
                            textAlign: 'center',
                        }}
                    >
                        <img
                            src={dataQr.image}
                            alt="qr"
                            style={{
                                width: '100%',
                                maxWidth: '240px',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto',
                            }}
                        />
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 1.5,
                        padding: '6px 16px',
                        borderRadius: '50px',
                        backgroundColor: tiempoRestante <= 60 ? '#fff0f0' : '#eef4ff',
                        border: `1px solid ${tiempoRestante <= 60 ? '#ffcdd2' : '#cfd8e8'}`,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: tiempoRestante <= 60 ? '#d84948' : '#1976d2',
                            fontWeight: 700,
                        }}
                    >
                        ⏱ Tiempo restante: {formatTiempo(tiempoRestante)}
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '10px',
                    padding: '12px 16px',
                    backgroundColor: '#f7f9fc',
                    borderTop: '1px solid #e0e7f1',
                    flexShrink: 0,
                }}
            >
                <ButtonStyleWhite
                    variant="contained"
                    style={{
                        flex: 1,
                        height: '46px',
                        borderRadius: '12px',
                        color: '#333',
                        fontSize: '13px',
                        fontWeight: 600,
                    }}
                    onClick={handleCancelarQrAction}
                >
                    Cancelar
                </ButtonStyleWhite>

                <ButtonStyleAzul
                    variant="contained"
                    style={{
                        flex: 1,
                        height: '46px',
                        borderRadius: '12px',
                        fontSize: '13px',
                        fontWeight: 600,
                    }}
                    startIcon={<Send />}
                    onClick={handleShare}
                >
                    Compartir
                </ButtonStyleAzul>
            </Box>
        </Dialog>
    )
}

export default QrComponents;